module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.currentTerms) ? _c('div', {
    staticClass: "terms panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Week")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentWeek),
      expression: "currentWeek"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentWeek = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getContent]
    }
  }, _vm._l((16), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i))])
  }))]), _vm._v(" "), _vm._l((_vm.currentTerms), function(term) {
    return _c('div', [_c('h4', [_vm._v("\n                " + _vm._s(term.name) + "                 \n            ")]), _vm._v(" "), _c('ul', [(term.instances.length === 0) ? _c('li', [_vm._v("No content this week")]) : _vm._e(), _vm._v(" "), _vm._l((term.instances), function(instance) {
      return _c('li', {
        staticClass: "clearfix"
      }, [_c('h5', {
        staticClass: "instance-name",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.selectedTerm = term.id;
            _vm.selectedInstance === instance.id ? _vm.selectedInstance = null : _vm.selectedInstance = instance.id
          }
        }
      }, [_c('span', {
        on: {
          "click": function($event) {
            _vm.selectedTab = 'description'
          }
        }
      }, [(_vm.selectedInstance === instance.id) ? _c('i', {
        staticClass: "fa fa-caret-down"
      }) : _c('i', {
        staticClass: "fa fa-caret-right"
      }), _vm._v("\n                            " + _vm._s(instance.associated.name) + "\n                        ")]), _vm._v(" "), (instance.video.assignment) ? _c('img', {
        attrs: {
          "src": require("./../../assets/img/assignment-icon.png")
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.selectedTab = 'assignment'
          }
        }
      }) : _vm._e(), _vm._v(" "), (instance.video.exercise) ? _c('img', {
        attrs: {
          "src": require("./../../assets/img/excercise-icon.png")
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.selectedTab = 'exercise'
          }
        }
      }) : _vm._e()]), _vm._v(" "), (_vm.selectedInstance === instance.id) ? _c('div', {
        staticClass: "video"
      }, [(instance.video) ? _c('div', {}, [_c('div', {
        staticClass: "panel col-xs-12 col-md-8 video-player-wrapper"
      }, [_c('div', {
        staticClass: "sku"
      }, [_vm._v("\n                                    " + _vm._s(instance.video.sku) + "\n                                ")]), _vm._v(" "), _c('div', {
        staticClass: "panel-heading"
      }, [_c('h2', [_vm._v(_vm._s(instance.video.title) + " — Week " + _vm._s(instance.video.week))])]), _vm._v(" "), _c('div', {
        staticClass: "panel-body"
      }, [(_vm.selectedChapter) ? _c('poly-video', {
        key: _vm.selectedChapter.id,
        ref: "videoPlayer",
        refInFor: true,
        attrs: {
          "sources": [_vm.videoPlayerUrl],
          "vjsOptions": _vm.videoPlayerVjsOptions,
          "persistPlaybackSpeed": true,
          "persistPlaybackQuality": true
        },
        on: {
          "ready": function($event) {
            _vm.getAnnotations($event), _vm.getMarkers($event)
          },
          "timeupdate": function($event) {
            _vm.onPlayerTimeupdate($event)
          }
        }
      }) : _c('img', {
        staticClass: "video-player-placeholder",
        attrs: {
          "src": require("./../../assets/img/video-admin-placeholder.png"),
          "alt": "Video Player"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "tabs clearfix"
      }, [_c('ul', [_c('li', {
        class: {
          'active': _vm.selectedTab === 'description'
        },
        on: {
          "click": function($event) {
            _vm.selectedTab = 'description'
          }
        }
      }, [_vm._v("\n                                                Description\n                                            ")]), _vm._v(" "), _c('li', {
        class: {
          'active': _vm.selectedTab === 'exercise'
        },
        on: {
          "click": function($event) {
            _vm.selectedTab = 'exercise'
          }
        }
      }, [_vm._v("\n                                                Exercise\n                                            ")]), _vm._v(" "), _c('li', {
        class: {
          'active': _vm.selectedTab === 'assignment'
        },
        on: {
          "click": function($event) {
            _vm.selectedTab = 'assignment'
          }
        }
      }, [_vm._v("\n                                                Assignment\n                                            ")]), _vm._v(" "), _c('li', {
        class: {
          'active': _vm.selectedTab === 'comments'
        },
        on: {
          "click": function($event) {
            _vm.selectedTab = 'comments'
          }
        }
      }, [_vm._v("\n                                                Comments\n                                            ")]), _vm._v(" "), _c('li', {
        class: {
          'active': _vm.selectedTab === 'resources'
        },
        on: {
          "click": function($event) {
            _vm.selectedTab = 'resources'
          }
        }
      }, [_vm._v("\n                                                Resources\n                                            ")]), _vm._v(" "), _c('li', {
        class: {
          'active': _vm.selectedTab === 'transcript'
        },
        on: {
          "click": function($event) {
            _vm.selectedTab = 'transcript'
          }
        }
      }, [_vm._v("Live Transcript")])])])], 1), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.selectedTab === 'description'),
          expression: "selectedTab==='description'"
        }],
        staticClass: "panel"
      }, [_vm._m(0, true), _vm._v(" "), _c('div', {
        staticClass: "panel-body"
      }, [_c('h4', [_vm._v("Lesson Description:")]), _vm._v(" "), _c('div', {
        domProps: {
          "innerHTML": _vm._s(instance.video.description)
        }
      }), _vm._v(" "), (_vm.requires(instance.video, 'files')) ? _c('div', [_c('h4', [_vm._v("Lesson Files:")]), _vm._v(" "), (instance.video && instance.video.lesson_files && instance.video.lesson_files.length === 0) ? _c('p', [_vm._v("No files for this lesson")]) : _vm._e(), _vm._v(" "), (instance.video && instance.video.lesson_files) ? _c('table', {
        staticClass: "assignment-files table table-striped"
      }, [_c('tbody', _vm._l((instance.video.lesson_files), function(file, index) {
        return _c('tr', {
          staticClass: "list-group-item"
        }, [_c('td', [_c('a', {
          attrs: {
            "href": file.url,
            "_target": "blank"
          }
        }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file.url)))])])])
      }))]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.selectedTab === 'assignment') ? _c('div', {
        staticClass: "panel"
      }, [_vm._m(1, true), _vm._v(" "), _c('div', {
        staticClass: "panel-body"
      }, [(instance.video.assignment) ? _c('div', [_c('form', [_c('div', {
        staticClass: "form-group"
      }, [_c('b', [_vm._v("Available: ")]), _vm._v("\n                                                    " + _vm._s(_vm._f("shortDate")(instance.video.assignment.availableDate)) + "\n                                                ")]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('b', [_vm._v("Due: ")]), _vm._v("\n                                                    " + _vm._s(_vm._f("shortDate")(instance.video.assignment.dueDate)) + "\n                                                ")]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('h5', [_vm._v("Final Project "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (instance.video.assignment.isFinalProject),
          expression: "instance.video.assignment.isFinalProject"
        }],
        attrs: {
          "type": "checkbox",
          "readonly": ""
        },
        domProps: {
          "checked": Array.isArray(instance.video.assignment.isFinalProject) ? _vm._i(instance.video.assignment.isFinalProject, null) > -1 : (instance.video.assignment.isFinalProject)
        },
        on: {
          "__c": function($event) {
            var $$a = instance.video.assignment.isFinalProject,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (instance.video.assignment.isFinalProject = $$a.concat([$$v]))
              } else {
                $$i > -1 && (instance.video.assignment.isFinalProject = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              instance.video.assignment.isFinalProject = $$c
            }
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('h5', [_vm._v("Name")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (instance.video.assignment.name),
          expression: "instance.video.assignment.name"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "readonly": ""
        },
        domProps: {
          "value": (instance.video.assignment.name)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            instance.video.assignment.name = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('h5', [_vm._v("Difficulty Level")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (instance.video.assignment.difficulty),
          expression: "instance.video.assignment.difficulty"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "readonly": ""
        },
        domProps: {
          "value": (instance.video.assignment.difficulty)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            instance.video.assignment.difficulty = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('h5', [_vm._v("Points")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (instance.video.assignment.points),
          expression: "instance.video.assignment.points"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "readonly": ""
        },
        domProps: {
          "value": (instance.video.assignment.points)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            instance.video.assignment.points = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('h5', [_vm._v("Description")]), _vm._v(" "), _c('div', {
        domProps: {
          "innerHTML": _vm._s(instance.video.assignment.description)
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('h5', [_vm._v("Assignment Image")]), _vm._v(" "), _c('img', {
        attrs: {
          "src": instance.video.assignment.image
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }), _vm._v(" "), _c('h5', [_vm._v("Files")]), _vm._v(" "), _c('table', {
        staticClass: "assignment-files table table-striped"
      }, [_c('tbody', _vm._l((instance.video.assignment.files), function(file, index) {
        return _c('tr', {
          staticClass: "list-group-item"
        }, [_c('td', [_c('a', {
          attrs: {
            "href": file,
            "_target": "blank"
          }
        }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file)))])])])
      }))]), _vm._v(" "), _c('table', {
        staticClass: "assignment-files table table-striped "
      }, [_c('tbody', _vm._l((instance.video.assignment.watermarkedFiles), function(file, index) {
        return _c('tr', {
          staticClass: "list-group-item"
        }, [_c('td', [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.downloadFile(file, 'assignment', instance.video.assignment.id)
            }
          }
        }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file)))])])])
      }))])])]) : _c('div', [_c('p', [_vm._v("No assignment for this lesson.")])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'exercise') ? _c('div', {
        staticClass: "panel exercise"
      }, [_vm._m(2, true), _vm._v(" "), _c('div', {
        staticClass: "panel-body"
      }, [(instance.video.exercise) ? _c('div', [_c('div', [_c('div', {
        staticClass: "form-group"
      }, [_c('h5', [_vm._v("Name")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (instance.video.exercise.title),
          expression: "instance.video.exercise.title"
        }],
        staticClass: "form-control",
        domProps: {
          "value": (instance.video.exercise.title)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            instance.video.exercise.title = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v("Due Date")]), _vm._v(" "), _c('br'), _vm._v("\n                                                    " + _vm._s(_vm._f("shortDate")(instance.video.exercise.dueDate)) + "\n                                                ")]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('h5', [_vm._v("Description:")]), _vm._v(" "), _c('div', {
        domProps: {
          "innerHTML": _vm._s(instance.video.exercise.description)
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('h5', [_vm._v("Exercise Image")]), _vm._v(" "), (instance.video.exercise.image) ? _c('img', {
        attrs: {
          "src": instance.video.exercise.image
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('h5', [_vm._v("Files")]), _vm._v(" "), _c('table', {
        staticClass: "assignment-files table table-striped "
      }, [_c('tbody', [_vm._l((instance.video.exercise.files), function(file, index) {
        return _c('tr', {
          staticClass: "list-group-item"
        }, [_c('td', [_c('a', {
          attrs: {
            "href": file,
            "_target": "blank"
          }
        }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file)))])])])
      }), _vm._v(" "), _vm._l((instance.video.exercise.watermarkedFiles), function(file, index) {
        return _c('tr', {
          staticClass: "list-group-item"
        }, [_c('td', [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.downloadFile(file, 'exercise', instance.video.exercise.id)
            }
          }
        }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file)))])])])
      })], 2)])])])]) : _c('div', [_c('p', [_vm._v("No exercise for this lesson")])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'comments') ? _c('div', {
        staticClass: "panel"
      }, [_vm._m(3, true), _vm._v(" "), _c('div', {
        staticClass: "panel-body"
      }, [(_vm.comments) ? _c('ul', {
        staticClass: "comments"
      }, _vm._l((_vm.comments), function(comment) {
        return _c('li', [_c('div', {
          staticClass: "row top-level"
        }, [_c('div', {
          staticClass: "col-xs-2"
        }, [(comment.user.avatar) ? _c('img', {
          attrs: {
            "src": comment.user.avatar
          }
        }) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "col-xs-7"
        }, [_c('p', {
          staticClass: "author"
        }, [_vm._v("\n                                                            " + _vm._s(comment.user.firstName) + " " + _vm._s(comment.user.lastName) + " at "), _c('span', {
          on: {
            "click": function($event) {
              _vm.jumpToTime(comment.time)
            }
          }
        }, [_vm._v(_vm._s(_vm._f("minutesAndSeconds")(comment.time)))])]), _vm._v(" "), _c('div', {
          domProps: {
            "innerHTML": _vm._s(comment.text)
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "col-xs-3"
        }, [_c('div', [_vm._v(_vm._s(_vm._f("timeSince")(comment.createdAt)) + " ago")]), _vm._v(" "), _c('div', [_c('button', {
          staticClass: "btn btn-xs reply-button",
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.showReplyForm = comment.id
            }
          }
        }, [_vm._v("Reply")])])])]), _vm._v(" "), (comment.children.length > 0) ? _c('ul', {
          staticClass: "replies"
        }, _vm._l((comment.children), function(child) {
          return _c('li', [_c('div', {
            staticClass: "row"
          }, [_c('div', {
            staticClass: "col-xs-2"
          }, [(child.user.avatar) ? _c('img', {
            attrs: {
              "src": child.user.avatar
            }
          }) : _vm._e()]), _vm._v(" "), _c('div', {
            staticClass: "col-xs-7"
          }, [_c('p', {
            staticClass: "author"
          }, [_vm._v("\n                                                                    " + _vm._s(child.user.firstName) + " " + _vm._s(child.user.lastName) + " at "), _c('span', {
            on: {
              "click": function($event) {
                _vm.jumpToTime(comment.time)
              }
            }
          }, [_vm._v(_vm._s(_vm._f("minutesAndSeconds")(comment.time)))])]), _vm._v(" "), _c('div', {
            domProps: {
              "innerHTML": _vm._s(child.text)
            }
          }), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
            staticClass: "col-xs-3"
          }, [_c('div', [_vm._v(_vm._s(_vm._f("timeSince")(comment.createdAt)) + " ago")])])])])
        })) : _vm._e(), _vm._v(" "), (_vm.showReplyForm === comment.id) ? _c('form', {
          on: {
            "submit": function($event) {
              $event.preventDefault();
              _vm.addComment(instance, comment.id, comment.user)
            }
          }
        }, [_c('div', {
          staticClass: "form-group"
        }, [_c('vue-html5-editor', {
          attrs: {
            "content": _vm.content,
            "height": 200
          },
          on: {
            "change": function($event) {
              _vm.updateCommentReply($event, comment.id)
            }
          }
        })], 1), _vm._v(" "), _c('button', {
          staticClass: "btn btn-xs reply-button",
          attrs: {
            "type": "submit"
          }
        }, [_vm._v("Submit Comment Reply")])]) : _vm._e()])
      })) : _vm._e(), _vm._v(" "), _c('form', {
        on: {
          "submit": function($event) {
            $event.preventDefault();
            _vm.addComment(instance)
          }
        }
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('label', [_vm._v("Add Timeline Comment:"), _c('i', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: ('Add and reply to comments directly on the timeline. Great for asking and answering questions specific to a point in time. Set your time marker to a place and add a comment!'),
          expression: "'Add and reply to comments directly on the timeline. Great for asking and answering questions specific to a point in time. Set your time marker to a place and add a comment!'"
        }],
        staticClass: "clippie fa fa-info-circle"
      })]), _vm._v(" "), _c('vue-html5-editor', {
        attrs: {
          "content": _vm.content,
          "height": 200
        },
        on: {
          "change": _vm.updateComment
        }
      })], 1), _vm._v(" "), _c('button', {
        staticClass: "btn btn-success",
        attrs: {
          "type": "submit"
        }
      }, [_vm._v("Add Comment")])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'resources') ? _c('div', {
        staticClass: "panel"
      }, [_vm._m(4, true), _vm._v(" "), _c('div', {
        staticClass: "panel-body resources"
      }, [(instance.video.resources) ? _c('div', [_c('div', {
        staticClass: "resource-table"
      }, [_c('ul', _vm._l((instance.video.resources), function(resource, index) {
        return _c('li', [_c('a', {
          attrs: {
            "href": resource.url,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(resource.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(resource.description))])])
      }))]), _vm._v(" "), _c('file-list', {
        attrs: {
          "instanceId": instance.id
        }
      })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'transcript') ? _c('div', {
        staticClass: "panel annotation"
      }, [_vm._m(5, true), _vm._v(" "), (_vm.selectedChapter) ? _c('div', {
        staticClass: "panel-body"
      }, [_c('table', {
        staticClass: "annotations"
      }, [_vm._m(6, true), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedChapter.annotations), function(annotation) {
        return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("timecode")(annotation.time)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(annotation.text))]), _vm._v(" "), _c('td', [_c('i', {
          staticClass: "fa fa-pencil",
          on: {
            "click": function($event) {
              _vm.editAnnotation(annotation.id)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "fa fa-trash-o",
          on: {
            "click": function($event) {
              _vm.deleteAnnotation(annotation.id)
            }
          }
        })])])
      }))])]) : _c('div', [_vm._v("Please select a chapter")])]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'transcript') ? _c('div', {
        staticClass: "panel"
      }, [_vm._m(7, true), _vm._v(" "), (_vm.selectedChapter) ? _c('div', {
        staticClass: "panel-body"
      }, [_c('p', [_vm._v("You can review the select chapter's video transcript below.")]), _vm._v(" "), _c('p', [_vm._v("They sometimes take up to an hour to generate but will appear once ready!")]), _vm._v(" "), _c('p', [_vm._v("You can edit them directly below and save your changes if they need improving.")]), _vm._v(" "), (_vm.selectedChapter && _vm.selectedChapter.transcript) ? _c('div', {
        staticClass: "transcript"
      }, [_c('div', {
        ref: "text",
        refInFor: true,
        staticClass: "text well"
      }, _vm._l((_vm.selectedChapter.transcript.text), function(phrase, index) {
        return _c('span', {
          attrs: {
            "contenteditable": "true"
          },
          on: {
            "keyup": function($event) {
              _vm.updateText($event, index)
            }
          }
        }, [_vm._v(_vm._s(_vm._f("nobreak")(phrase.text)) + " ")])
      })), _vm._v(" "), _c('div', {
        staticClass: "form-group"
      }, [_c('button', {
        staticClass: "btn btn-primary",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.updateTranscript($event)
          }
        }
      }, [_vm._v("Save Transcript Edits")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedChapter) ? _c('button', {
        staticClass: "btn btn-default",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.regenerateTranscript()
          }
        }
      }, [_vm._v("Regenerate Transcript")]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "panel col-xs-12 col-md-4"
      }, [_vm._m(8, true), _vm._v(" "), _c('div', {
        staticClass: "panel-body chapters"
      }, [_c('ul', _vm._l((instance.video.video_chapters), function(chapter, index) {
        return _c('li', {
          staticClass: "row video-chapter"
        }, [(chapter.heading) ? _c('div', {
          staticClass: "col-xs-12 chapter-heading form-group"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (chapter.heading),
            expression: "chapter.heading"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "readonly": ""
          },
          domProps: {
            "value": (chapter.heading)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              chapter.heading = $event.target.value
            }
          }
        })]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "col-xs-12"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (chapter.title),
            expression: "chapter.title"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "readonly": ""
          },
          domProps: {
            "value": (chapter.title)
          },
          on: {
            "click": function($event) {
              _vm.selectChapter(chapter)
            },
            "input": function($event) {
              if ($event.target.composing) { return; }
              chapter.title = $event.target.value
            }
          }
        })])])
      }))]), _vm._v(" "), _vm._m(9, true), _vm._v(" "), _c('div', {
        staticClass: "panel-body summary"
      }, [_c('div', [_c('div', {
        domProps: {
          "innerHTML": _vm._s(instance.video.summary)
        }
      })])])])]) : _vm._e()]) : _vm._e()])
    })], 2)])
  })], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Lesson Description & Files")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading assignments"
  }, [_c('h2', [_c('img', {
    attrs: {
      "src": require("../../assets/img/assignment-icon.png")
    }
  }), _vm._v("Assignments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Exercise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Comments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Course Resources")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Annotations & Flyouts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Timecode")]), _vm._v(" "), _c('th', [_vm._v("Annotation")]), _vm._v(" "), _c('th', [_vm._v("Edit")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Transcript Editor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Chapters")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Weekly Summary")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c84ca96!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/SupervisorWeeklyContent.vue
// module id = 2059
// module chunks = 2